module.exports = __webpack_public_path__ + "static/img/PFK_OurStory_Photo5_390x390.1a522e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PFK_OurStory_Photo5_390x390.jpg
// module id = 326
// module chunks = 2